import { assign } from 'xstate';

import { B2BLeadFlowContext } from './types';

export const resetProduct = assign(({ context }: { context: B2BLeadFlowContext }) => ({
  ...context,
  product: undefined,
}));
